var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showDialog
    ? _c(
        "div",
        { class: ["dialog-container", { "is-mobile": _vm.isMobile }] },
        [
          _c("div", { staticClass: "dialog-background" }),
          _c("div", { staticClass: "dialog-message-container" }, [
            _c("header", { class: ["header-container", _vm.getType] }, [
              _c("img", { attrs: { src: _vm.getIcon, alt: "icon" } }),
            ]),
            _c("div", { staticClass: "message-container" }, [
              _c("p", {
                staticClass: "message",
                domProps: { innerHTML: _vm._s(_vm.dialog.message) },
              }),
            ]),
            _c(
              "div",
              { staticClass: "actions-container" },
              [
                !_vm.buttons
                  ? [
                      _vm.checkIfShowSecondaryButton
                        ? _c("LfLabelButtonComponent", {
                            staticClass: "button",
                            attrs: {
                              text: _vm.secondaryButtonText,
                              action: () => _vm.checkCloseDialog(),
                              variant: "outlined",
                            },
                          })
                        : _vm._e(),
                      _c("LfLabelButtonComponent", {
                        staticClass: "button",
                        attrs: {
                          text: _vm.mainButtonText,
                          action: () => _vm.makeAction(),
                          variant: "solid",
                        },
                      }),
                    ]
                  : _vm._l(_vm.buttons, function (button, index) {
                      return _c("LfLabelButtonComponent", {
                        key: index,
                        class: `button ${button.style}`,
                        attrs: {
                          action: () => _vm.getAction(button),
                          variant: button.variant,
                          text: button.text,
                        },
                      })
                    }),
              ],
              2
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }